import { Component } from '@angular/core';
import { EidosIconTooltipPosition } from '../eidos-icon/eidos-icon.component';
import { takeUntil } from 'rxjs';

import { EidosConfigService } from '@common/config/eidos-config.service';
import { IEidosIcon } from '@common/config/environment.interface';
import { EidosSecurityService } from '@common/services/eidos-security.service';
import { EidosIconType, CoreRoute } from '@common/models/core-constant.model';
import { EidosUser } from '@common/models/user-info.model';
import { EidosBaseComponent } from '../eidos-base.component';
import { CoreModuleRedirectorService } from '@app/core/services/core-module-redirector.service';

@Component({
  selector: 'eidos-topbar',
  templateUrl: './eidos-topbar.component.html',
  styleUrls: ['./eidos-topbar.component.scss']
})
export class EidosTopbarComponent extends EidosBaseComponent {
  /**
   * Company logo icon configuration
   *
   * @type {IEidosIcon}
   * @memberof EidosTopbarComponent
   */
  protected companyLogo: IEidosIcon | null = null;
  /**
   * Logo icon configuration
   *
   * @type {IEidosIcon}
   * @memberof EidosTopbarComponent
   */
  protected logo: IEidosIcon;
  /**
   * Hide Company Name from configuration
   *
   * @type {boolean}
   * @memberof EidosTopbarComponent
   */
  protected hideCompanyName: boolean = false;
  /**
   * Logo icon tooltip position
   *
   * @type {EidosIconTooltipPosition}
   * @memberof EidosTopbarComponent
   */
  protected logoIconTooltipPosition: EidosIconTooltipPosition = "right";
  /**
   * Current user
   *
   * @type {EidosUser}
   * @memberof EidosTopbarComponent
   */
  protected user: EidosUser | undefined;
  /**
   * Landing page
   *
   * @private
   * @type {string}
   * @memberof EidosTopbarComponent
   */
  private landingPage?: string;

  constructor(
    private eidosConfigService: EidosConfigService
    , private eidosSecurityService: EidosSecurityService
    , private coreModuleRedirectorService: CoreModuleRedirectorService
  ) {
    super();
    this.logo = this.eidosConfigService.DEFAULT_CONFIG.logo;
  }

  ngOnInit(): void {

    super.ngOnInit();

    this.eidosConfigService.currentConfig
      .pipe(takeUntil(this.subscription))
      .subscribe(config => {
        this.logo = config.logo;
        if (config.hideCompanyName) {
          this.hideCompanyName = config.hideCompanyName;
        }
        if (config.landingPage) {
          this.landingPage = config.landingPage;
        }
      });

    this.eidosSecurityService.currentLoggedUser
      .pipe(takeUntil(this.subscription))
      .subscribe(user => {
        this.loadNewUser(user);
      });
  }
  /**
   * Load a new user in the topbar
   *
   * @private
   * @param {EidosUser} user
   * @memberof EidosTopbarComponent
   */
  private loadNewUser(user: EidosUser) {
    this.user = user;

    if (user.landingObject) {
      // TODO
    }

    if (!!user.companyLogo) {
      this.companyLogo = {
        iconType: EidosIconType.MyBiz,
        iconCode: user.companyLogo,
        iconSize: 1
      };
    } else {
      this.companyLogo = null;
    }
  }
  /**
   * Redirect user to homepage while pressing on main logo
   *
   * @private
   * @memberof EidosTopbarComponent
   */
  protected navigateToHome(): void {
    const landingPage = !!this.landingPage ? this.landingPage : CoreRoute.Home;
    this.coreModuleRedirectorService.appNavigate([landingPage]);
  }
}
